export const authDataSelector = state => state?.auth?.data
export const isLoadingTokenSelector = state => state?.auth?.isLoading
export const accessTokenSelector = state => state?.auth?.access_token
